import {
  IMPORT_AGENCIES_CSV,
  IMPORT_CUSTOMER_CSV,
  IMPORT_DRIVERS_CSV,
} from "../services/ApiCalls";
import URLS from "../services/URLS";

export const paginationLimitOptionArr = [2, 5, 10, 20, 100, 200, 500, 1000];
export const statusFilterOptionArr = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];
export const serviceTypeFilterOptionArr = [
  { value: "", label: "All" },
  { value: "PickupDrop", label: "PickupDrop" },
  { value: "Towing", label: "Towing" },
];
export const openCloseFilterOptionArr = [
  { value: "", label: "All" },
  { value: "open", label: "Open" },
  { value: "close", label: "Close" },
];
export const GroupByFilterOptionArr = [
  { value: "days", label: "Days" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
];

export const csvImportEnum = {
  customers: {
    title: "Customers",
    sampleUrl: URLS.API_URL + "public/importUser.csv",
    api: (data) => IMPORT_CUSTOMER_CSV(data),
  },
  agency: {
    title: "Agency",
    sampleUrl: URLS.API_URL + "public/importProvider.csv",
    api: (data) => IMPORT_AGENCIES_CSV(data),
  },
  drivers: {
    title: "Drivers",
    sampleUrl: URLS.API_URL + "public/importDriver.csv",
    api: (data) => IMPORT_DRIVERS_CSV(data),
  },
};
